'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@/utils');

/*
*@des 获取图片资源
*@param {String} key vm实例上的key
*@param {String} type 图片类型
*@param {String} id 图片ID
*@example getImageSrc('courseSrc', 'course', '123)
*/
exports.default = {
  methods: {
    getImgSrc: function getImgSrc(key, type, id, isOpen) {
      var _this = this;

      var imgSrc = (0, _utils.imagePath)(type, id, isOpen);
      if (typeof imgSrc === 'string') return this[key] = imgSrc;
      imgSrc.then(function (res) {
        var src = typeof res === 'string' ? res : res.default;
        _this[key] = src;
      });
    }
  }
};